export default [
  {
    id: 1,
    type: "live",
    os: "IOS 14",
    imgPath: "/images/tutorial-items/i1.svg",
    like: true,
    duration: "05:38",
    steps: 26,
    screens: 88,
    description: "How to Install MacOS Big Sur",
    folders: ["Maxthon"],
    // img: () => <img src={I1} width={"100%"} />
  },
  {
    id: 2,
    type: "live",
    os: "WINDOWS 10",
    like: false,
    duration: "05:38",
    steps: 20,
    screens: 3,
    imgPath: "/images/tutorial-items/i2.svg",
    description: "Download Mozilla Firefox for Windows",
    folders: ["Chroom"],
    // img: () => <img src={I2} width={"100%"} />
  },
  {
    id: 3,
    type: "live",
    os: "ANDROID 11",
    like: true,
    duration: "15:38",
    steps: 21,
    screens: 5,
    imgPath: "/images/tutorial-items/i3.svg",
    description: "MacOS Big Sur Tips & Tiricks ",
    folders: ["Safari"],
    // img: () => <img src={I3} width={"100%"} />
  },
  {
    id: 4,
    type: "live",
    os: "WINDOWS 10",
    like: true,
    duration: "09:47",
    steps: 22,
    screens: 6,
    imgPath: "/images/tutorial-items/i4.svg",
    description: "Mozilla Firefox Lite",
    folders: [],
    // img: () => <img src={I4} width={"100%"} />
  },
  {
    id: 5,
    type: "upcoming",
    os: "IOS 14",
    like: true,
    duration: "03:00",
    steps: 10,
    screens: 9,
    imgPath: "/images/tutorial-items/i5.svg",
    description: "New Features in MacOS Big Sur",
    folders: ["Safari"],
    // img: () => <img src={I5} width={"100%"} />
  },
  {
    id: 6,
    type: "upcoming",
    os: "ANDROID 11",
    like: false,
    duration: "00:10",
    steps: 2,
    screens: 1,
    imgPath: "/images/tutorial-items/i6.svg",
    description: "Disable Password Pop-ips on Firefox",
    folders: ["Firefox"],
    // img: () => <img src={I6} width={"100%"} />
  },
  {
    id: 7,
    type: "upcoming",
    os: "IOS 14",
    like: false,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i7.svg",
    description: "How to Delete & Reinstall macOS Big Sur",
    folders: ["Flock"],
    // img: () => <img src={I7} width={"100%"} />
  },
  {
    id: 8,
    type: "upcoming",
    os: "WINDOWS 10",
    like: false,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i8.svg",
    description: "How to Delete & Reinstall macOS Big Sur",
    folders: ["Firefox"],
    // img: () => <img src={I8} width={"100%"} />
  },
  {
    id: 9,
    type: "upcoming",
    os: "ANDROID 11",
    like: false,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i9.svg",
    description: "Recover Files on MacOS Big Sur",
    folders: [],
    // img: () => <img src={I9} width={"100%"} />
  },
  {
    id: 10,
    type: "upcoming",
    os: "WINDOWS 10",
    like: false,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i10.svg",
    description: "MacOS Monterey",
    folders: [],
    // img: () => <img src={I10} width={"100%"} />
  },
  {
    id: 11,
    type: "past",
    os: "IOS 14",
    like: true,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i11.svg",
    description: "MacOS Catalina",
    folders: [],
    // img: () => <img src={I11} width={"100%"} />
  },
  {
    id: 12,
    type: "past",
    os: "WINDOWS 10",
    like: false,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i12.svg",
    description: "MacOS Mojave",
    folders: [],
    // img: () => <img src={I12} width={"100%"} />
  },
  {
    id: 13,
    type: "past",
    os: "IOS 14",
    like: false,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i13.svg",
    description: "MacOS High Sierra",
    folders: [],
    // img: () => <img src={I13} width={"100%"} />
  },
  {
    id: 14,
    type: "past",
    os: "ANDROID 11",
    like: false,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i14.svg",
    description: "MacOS Sierra",
    folders: [],
    // img: () => <img src={I14} width={"100%"} />
  },
  {
    id: 15,
    type: "past",
    os: "IOS 14",
    like: false,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i15.svg",
    description: "OS X El Capitan",
    folders: [],
    // img: () => <img src={I15} width={"100%"} />
  },
  {
    id: 16,
    type: "past",
    os: "WINDOWS 10",
    like: true,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i16.svg",
    description: "OS X Yosemite",
    folders: [],
    // img: () => <img src={I16} width={"100%"} />
  },
  {
    id: 17,
    type: "live",
    os: "ANDROID 11",
    like: false,
    duration: "05:38",
    steps: 20,
    screens: 5,
    imgPath: "/images/tutorial-items/i17.svg",
    description: "OS X Mavericks",
    folders: [],
    // img: () => <img src={I17} width={"100%"} />
  },
];
